import React, {useEffect, useMemo, useRef, useState} from 'react';
import './measures.scss';
import {Col, Row} from 'react-bootstrap';
import SectionHeader from './sectionHeader/SeactionHeader';
import MeasuresFormShow from '../../components/MeasuresForm/MeasuresFormShow';
import MeasuresFormAdd from '../../components/MeasuresForm/MeasuresFormAdd';
import {
  getAllMeasures
} from '../../services/measuresService/measuresApi';
import {t} from 'react-switch-lang';
import OpenIcon from './img/Arrow.svg';
import {useUserContext} from '../../contexts/UserContext';
import {useDepartmentContext} from '../../contexts/DepartmentContext';
import {ReactComponent as PlusImg} from './img/WhitePlus.svg';
import {Spin} from 'antd';
import {getCourtRiskId} from '../../services/getRisk';
import * as yup from "yup";
import {defaultMinValueZero, validDouble} from "../../utils/const";
import {maxDecimalNumber, testIsGreaterThanMin, testValidNumber} from "../../utils/helpers";
import {FormProvider, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers";
import MeasureTab from "./components/MeasureTab";


const MainRiskMeasure = ({defaultData,
  allowNewMeasure,
  userInChargeRisk,
  responsiblePersonRisk,
  id,
  tab,
  estimatedGrossLost,
  riskStatusId
}) => {

  const queryString = require('query-string');
  const parsed = queryString.parse(window.location.search);
  const urlCheck = window.location.pathname;
  let activeMeasure = 0;
  const [open, setOpen] = useState(activeMeasure);
  const user = useUserContext();
  const departments = useDepartmentContext();
  const [meausresData, setMeasuresData] = useState([]);
  const [addNew, setAddNew] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  // disabled, schema and methods added here because some methods are needed in sectionHeader and MeasuresFormShow
  const [disabled, setDisabled] = useState(true);


  const [schema, setScheme] = useState(yup.object().shape({
    realizationDate: yup
        .string()
        .nullable()
        .trim()
        .required(t('message.fieldRequired')),
    riskAnalysis: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(2000, t('message.max', {max: 2000})),
    levelOfMeasureRealization: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
    cost: yup.object().nullable().required(t('message.fieldRequired')),
    department: yup.object().nullable().required(t('message.fieldRequired')),
    grossLoss: yup
        .string()
        .trim()
        .test('is-greater-than-min', t('message.minValue', {min: defaultMinValueZero}), (value) => {
          return testIsGreaterThanMin(value,defaultMinValueZero);
        })
        .test('is-valid-number', t('message.mustBeNumber'), (value) => {
          return testValidNumber(value,true);
        }).test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
          return maxDecimalNumber(value);
        })
        .typeError(t('message.onlyDecimalNumbers')),
    lossChargedInsurance: yup
        .string()
        .trim()
        .test('is-greater-than-min', t('message.minValue', {min: defaultMinValueZero}), (value) => {
          return testIsGreaterThanMin(value,defaultMinValueZero);
        })
        .test('is-valid-number', t('message.mustBeNumber'), (value) => {
          return testValidNumber(value,true);
        }).test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
          return maxDecimalNumber(value);
        })
        .typeError(t('message.onlyDecimalNumbers')),
    lossChargedOther: yup
        .string()
        .trim()
        .test('is-greater-than-min', t('message.minValue', {min: defaultMinValueZero}), (value) => {
          return testIsGreaterThanMin(value,defaultMinValueZero);
        })
        .test('is-valid-number', t('message.mustBeNumber'), (value) => {
          return testValidNumber(value,true);
        }).test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
          return maxDecimalNumber(value);
        })
        .typeError(t('message.onlyDecimalNumbers')),
    netLoss: yup
        .string()
        .trim()
        .test('is-greater-than-min', t('message.minValue', {min: defaultMinValueZero}), (value) => {
          return testIsGreaterThanMin(value,defaultMinValueZero);
        })
        .test('is-valid-number', t('message.mustBeNumber'), (value) => {
          return testValidNumber(value,true);
        }).test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
          return maxDecimalNumber(value);
        })
        .typeError(t('message.onlyDecimalNumbers')),
    mitigationMeasures: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(2000, t('message.max', {max: 2000})),
    hdRequestId: yup.string().trim(),
    mitigationPercentage: yup
        .string()
        .trim()
        .matches(validDouble, t('message.onlyDecimalNumbers'))
        .typeError(t('message.onlyDecimalNumbers'))
        .test('max-100', t('message.maxValue', { max: 100 }), value => {
          const num = parseFloat(value?.replace(',', '.') ?? '');
          return isNaN(num) || num <= 100;
        }),
    additionalMitigationMeasures: yup
        .string()
        .trim()
        .max(2000, t('message.max', {max: 2000})),
  }));


  const formMethodsRef = useRef({});



  const [testId, setTestId] = useState(id);
  // let testId = id;
  const fetchData = async () => {
    try {
      let {data} = await getAllMeasures(id);
      setMeasuresData(
        data.sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated))
      );
      for (let i = 0; i < data.length; i++) {
        if(parsed.measure === data[i].id.toString()) {
          activeMeasure = i;
          setOpen(activeMeasure);
        }
      }
      setIsLoading(false);
    } catch (err) {
      if (err) {
      }
    }
  };

  const toggleAdd = () => {
    setAddNew(!addNew);
  };

  useEffect(() => {
    if (addNew === true) {
      setOpen('');
    } else {
      setOpen(activeMeasure);
    }
  }, [addNew]);

  useEffect(() => {
    if(urlCheck.toString().includes('court-risk') && window.location.search.toString().includes('tab=measures')) {
      getCourtRiskId(id).then((r) => {
        setTestId(r.data.risk.id);
        getAllMeasures(r.data.risk.id).then((r) => {
          setMeasuresData(
            r.data.sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated))
          );
          for (let i = 0; i < r.data.length; i++) {
            if(parsed.measure === r.data[i].id.toString()) {
              activeMeasure = i;
              setOpen(activeMeasure);
            }
          }
          setIsLoading(false);
        });
      });
    } else {
      fetchData();
    }
  }, []);


  return (
    <>
      {isLoading ? (
        <Spin spinning={isLoading} size={'large'} className="spinner" />
      ) : (
        <div style={{width: '100%'}}>
          {(window.location.pathname.includes('court-risk') ? (defaultData?.risk?.active === true) : (defaultData?.active === true)) && allowNewMeasure && (
            <Row className={`px-5 mt-3 py-3 right-btns`}>
              <Col lg={12} className="btns-float-right">
                <button
                  type="button"
                  className="primary-btn mr-2 float-right"
                  onClick={() => toggleAdd()}
                >
                  <PlusImg />
                  <span className="ml-2">{t('buttons.addNewMeasure')}</span>
                </button>
              </Col>
            </Row>
          )}

          {addNew && (
            <>
              <Row className={`px-5 mt-3 py-3`}>
                <div className={`w-100 measure-section-container open`}>
                  <div className="section-header  justify-content-between align-items-center">
                    <div className="hover-effect  align-items-center">
                      <div className="section-icon">
                        <img src={OpenIcon} className={`open`} alt="Icon" />
                      </div>
                    </div>
                  </div>
                  <div className={`w-100 section-content open`}>
                    <div className="measure-form">
                      <MeasuresFormAdd
                        userData={user}
                        toggleOpen={toggleAdd}
                        open={true}
                        departmentData={departments}
                        id={id}
                        tab={tab}
                        estimatedGrossLost={estimatedGrossLost}
                      />
                    </div>
                  </div>
                </div>
              </Row>
            </>
          )}

          {meausresData.length > 0 ? (
            meausresData.map((item, idx) => {
              return (
                <MeasureTab propsObj={{open,setOpen,idx,responsiblePersonRisk,userInChargeRisk,item,setDisabled,id,riskStatusId,allowNewMeasure,setScheme,schema,disabled,estimatedGrossLost}}/>
              );
            })
          ) : (
              <div className="no-measures">{t('common.noMeasures')} </div>
          )}
        </div>
      )}
    </>
  );
};

export default MainRiskMeasure;
